<template>
  <v-btn style="height: 43px"
         @click="connectQuickbooksAccount"
         class="pt-0 ml-1 pl-0 pr-0 mr-2"
         :loading="loading || connectButtonLoading">
    <img class="align-center cursor-pointer"
         height="43"
         :src="qbImageButton"
         @mouseover="qbImageButton = qbImageHover"
         @mouseleave="qbImageButton = qbImage"/>
  </v-btn>
</template>

<script>

import QuickbooksMixin from '../../mixins/quickbooksMixin';
import firebase from 'firebase';
import API from '@/api';

export default {
  name: 'VQuickbooksConnectBtn',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    companyId: {
      type: String,
      required: true,
    },
  },
  mixins: [
    QuickbooksMixin,
  ],
  data() {
    return {
      connectButtonLoading: false,
      qbImage: '/static/C2QB_green_btn_lg_default.png',
      qbImageHover: '/static/C2QB_green_btn_lg_hover.png',
      qbImageButton: null,
    };
  },
  methods: {
    async connectQuickbooksAccount() {
      this.connectButtonLoading = true;

      this.$emit('connecting');

      const basePath = `message_list/${this.companyId}`;
      const apiResponse = await API.quickBooks.initiate({ companyId: this.companyId });
      const dbRef = firebase.database();
      const newMessageRef = dbRef.ref(basePath).push();
      newMessageRef.set({
        refresh: false,
      });

      localStorage.setItem('QbMessagePath', newMessageRef.key);

      this.refDbKey = dbRef.ref(`${basePath}/${newMessageRef.key}`);
      this.refDbKey.on('value', this.onDbUpdate);

      window.open(apiResponse.data.url, 'Quickbooks Auth', 'width=700,height=500,toolbar=0,menubar=0');
    },
    async onDbUpdate(snapshot) {
      const v = snapshot.val();
      if (v.refresh) {
        this.connectButtonLoading = false;
        this.cleanDbRef();

        await this.$store.dispatch('companies/getProfileCompany', { id: this.companyId });
        this.loadCompanyQuickbooksInfo(this.companyId);

        this.$emit('connected');
      }
    },
    cleanDbRef() {
      if (this.refDbKey) {
        this.refDbKey.off('value', this.onDbUpdate);
        const dbRef = firebase.database().ref(`message_list/${this.companyId}`);
        dbRef.remove();
        this.refDbKey = null;
      }
    },
  },
  created() {
    this.qbImageButton = this.qbImage;
  },
};
</script>



// WEBPACK FOOTER //
// src/components/qb/QuickbooksConnectButton.vue